import React, { memo, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api from '../../../api'
import { ErrorModal } from '../../../components/Modal'
import CreateUserStyle from './CreateUserStyle'
import { useSelector } from 'react-redux'
import customMainApi from '../../../api'
import ClipLoader from 'react-spinners/ClipLoader'
import formatPhoneNumber from '../../../helpers/PhoneWithSpaces'
import { useTranslation } from 'react-i18next'
import { Button as AntButton } from 'antd'
import { cleanedPhneNumber } from '../../../utils/formatNumber'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		border: 'none',
		borderRadius: 15,
		overflowX: 'auto',
	},
}

const UpdateUserModal = (props) => {
	const { getRef = () => {}, onUpdated = () => {}, onClose = () => {} } = props
	const { getMe } = useSelector((state) => state.main)
	const { t } = useTranslation()

	const errorRef = useRef()
	const [isOpenModal, setIsOpenModal] = useState(false)
	const [cardCode, setCardCode] = useState('')
	const [phone, setPhone] = useState('')
	const [userFields, setUserFields] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [bpLoading, setBpLoading] = useState(false)
	const [email, setEmail] = useState('')
	const [typeAccount, setTypeAccount] = useState('')
	const [password, setPassword] = useState('')
	const [name, setName] = useState('')
	const [status, setStatus] = useState('')

	useEffect(() => {
		const ref = {
			open: (data) => {
				setIsOpenModal(true)

				setCardCode(get(data, 'Code', ''))
				setName(get(data, 'Name', ''))
				setPassword(get(data, 'U_Password', ''))
				// setPhone(formatPhoneNumber(get(data, 'U_Whichtelephone', '')))
				setPhone(get(data, 'U_Whichtelephone', ''))
				setTypeAccount(get(data, 'U_TypeAccount', ''))
				setStatus(get(data, 'U_Status', ''))
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	const submit = () => {
		setIsLoading(true)
		let url = `Security('${cardCode}')`

		api
			.patch(url, {
				Name: name,
				U_Whichtelephone: cleanedPhneNumber(phone),
				U_Password: password,
				U_Status: status,
			})
			.then(() => {
				onUpdated()
				setIsOpenModal(false)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => setIsLoading(false))
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq '@Security'",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}
	useEffect(() => {
		userFieldsFn()
	}, [])

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<CreateUserStyle>
				<div className="card">
					<p className="title">{t('editIcloud')}</p>
					{bpLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="flex flex-col gap-4 mt-10">
								<div className="flex flex-col sm:flex-row items-center gap-5">
									<div className="flex flex-col gap-2 items-start w-full">
										<p>{t('icloud')}</p>
										<input
											type="text"
											placeholder={t('icloud')}
											className={
												'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full h-10'
											}
											value={name}
											onChange={(v) => setName(v.target.value)}
										/>
									</div>
									<div className="flex flex-col gap-2 items-start w-full">
										<p>{t('phone')}</p>
										<textarea
											type="text"
											placeholder={t('phone')}
											className={
												'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
											}
											value={formatPhoneNumber(phone || '')}
											onChange={(v) => setPhone(v.target.value)}
										/>
									</div>
								</div>
								<div className="flex flex-col sm:flex-row  items-center gap-5">
									<div className="flex flex-col gap-2 items-start w-full">
										<p>{t('password')}</p>
										<input
											type="text"
											placeholder={t('password')}
											className={
												'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
											}
											value={password}
											onChange={(v) => setPassword(v.target.value)}
										/>
									</div>
									<div className="flex flex-col gap-2 items-start w-full">
										<p>{t('status')}</p>
										<select
											placeholder={t('status')}
											className={
												'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
											}
											value={status}
											onChange={(v) => setStatus(v.target.value)}
										>
											{' '}
											<option value={''}></option>
											{userFields
												?.find((item) => item.Name === 'Status')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</div>
								</div>
							</div>

							<div className="flex flex-col sm:flex-row items-center justify-between mt-5 sm:mt-10 w-full">
								<AntButton
									className="bg-red-500 h-10 hover:bg-red-100 text-white py-2 px-4 w-full sm:w-auto rounded-md btn"
									onClick={() => {
										onClose()
										setIsOpenModal(false)
									}}
								>
									{t('no')}
								</AntButton>
								<AntButton
									loading={isLoading}
									className={
										'bg-[#0A4D68] h-10 text-white py-2 px-4 w-full sm:w-auto rounded-md btn'
									}
									onClick={submit}
								>
									{t('yes')}
								</AntButton>
							</div>
						</>
					)}
				</div>
			</CreateUserStyle>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
		</Modal>
	)
}

export default memo(UpdateUserModal)
